import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=367fe498&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"
import style0 from "./menu.vue?vue&type=style&index=0&id=367fe498&prod&lang=less&scoped=true"
import style1 from "./menu.vue?vue&type=style&index=1&id=367fe498&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367fe498",
  null
  
)

export default component.exports